import { Media } from "@contracts/interfaces/media.interfaces";

export class ReceiptFactory {

    dateAdded: Date;
    file: Media | null;
    sha1: string;
    date: Date | null;
    vender: string;
    lineItems: string[];
    currency: string;
    amount: string;
    transactionID: string | null;
    deleted: boolean;
    missingFile: boolean;
    note: string;
    chatGPTProcessedAt: Date | null;
    matchedTransactionAmount: number | null;
    linkedReceiptTotalAmount: number | null;
    linkedReceiptCount: number | null;
    linkedReceiptAmountsComplete: boolean | null;

    constructor(raw: any) {

        // --- Dates ---
        this.dateAdded = this.toDate(raw.dateAdded);
        this.date = this.toDate(raw.date);
        this.chatGPTProcessedAt = this.toDate(raw.chatGPTProcessedAt);

        // --- Strings (defaults to empty) ---
        this.sha1 = this.toStringOrEmpty(raw.sha1);
        this.vender = this.toStringOrEmpty(raw.vender);
        this.currency = this.toStringOrEmpty(raw.currency);
        this.amount = raw.amount;
        this.transactionID = this.toStringOrNull(raw.transactionID);
        this.note = this.toStringOrEmpty(raw.note);
        this.matchedTransactionAmount = typeof raw.matchedTransactionAmount === 'number'
            ? raw.matchedTransactionAmount
            : null;
        this.linkedReceiptTotalAmount = typeof raw.linkedReceiptTotalAmount === 'number'
            ? raw.linkedReceiptTotalAmount
            : null;
        this.linkedReceiptCount = typeof raw.linkedReceiptCount === 'number'
            ? raw.linkedReceiptCount
            : null;
        this.linkedReceiptAmountsComplete = typeof raw.linkedReceiptAmountsComplete === 'boolean'
            ? raw.linkedReceiptAmountsComplete
            : null;

        // --- Arrays ---
        this.lineItems = Array.isArray(raw.lineItems) ? raw.lineItems : [];

        // --- Media ---
        this.file = raw.file ?? null;

        // --- Booleans ---
        this.deleted = !!raw.deleted;
        this.missingFile = !!raw.missingFile;
    }

    // --- Helpers ---
    private toDate(v: any): Date {
        if (!v) return null;

        // If already a Date instance:
        if (v instanceof Date) {
            return isNaN(v.getTime()) ? null : v;
        }

        // Attempt parse from string
        const d = new Date(v);
        return isNaN(d.getTime()) ? null : d;
    }

    private toStringOrEmpty(v: any): string {
        return typeof v === 'string' ? v : '';
    }

    private toStringOrNull(v: any): string | null {
        if (typeof v === 'string' && v.trim().length > 0) {
            return v;
        }
        return null;
    }

}
